import { createSystem, defineConfig, defaultConfig } from "@chakra-ui/react"

const customConfig = defineConfig({
    cssVarsRoot: ":where(:root, :host)",
    theme: {
        tokens: {
            colors: {
                primary: { value: '#323232'},
                secondary: { value: '#646464'},
            }
        },
        semanticTokens: {
            colors: {
                brand: {
                    solid: { value: "#E24F4B" },
                    contrast: { value: "#FFFFFF" },
                    fg: { value: "#FEE4037" },
                    muted: { value: "#FFC4BE" },
                    subtle: { value: "#FFE4E4" },
                    emphasized: { value: "#FFC4BE" },
                    focusRing: { value: "#F46561" },
                },
                text: {
                    muted: { value: '#646464'},
                    subtle: { value: '#BDBDBD'},
                },
                gray: {
                    focusRing: { value: '#6F6F6F'}
                }
            }
        }
    }
})

export const system = createSystem(defaultConfig, customConfig);